import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Input from "../../../Common/Components/Input";

interface Props {
  listName: string;
  addNewListFlow?: boolean;
  setListName: (value: string) => void;
  newListErrorMessage?: boolean;
}

const NewListModule: React.FC<Props> = (props) => {
  const { listName, setListName, newListErrorMessage, addNewListFlow } = props;
  // const [listName, setListName] = useState("");
  const [descriptionValue, setDescriptionValue] = useState("");
  const [listAlreadyExists, setListAlreadyExists] = useState(false);
  return (
    <Wrapper className={`dropdown-create-new-list ${addNewListFlow ? 'add-new-list-flow' : ''}`}>
      <Input
        label="Name your list"
        placeholder="Type your list name"
        onChange={setListName}
        value={listName}
        idInput="give-this-campaign-a-unique-name"
        maxLength={100}
        error={
          newListErrorMessage
            ? "List already exists."
            : null
        }
        errorClassName={"error-message-styles"}

      />
      <div className="wrapper">
        <h3 className="add-word-head">{"Add description"}</h3>
        {<span className="sub-text">(optional)</span>}
      </div>
      <div className="margined-input">
        <TextArea
          autoSize={{ minRows: 3, maxRows: 3 }}
          placeholder="Start typing your description..."
          rows={4}
          onChange={(e: any) => {
            setDescriptionValue(e.target.value);
          }}
          value={descriptionValue}
          className="round-field"
        />
      </div>
    </Wrapper>
  );
};

export default NewListModule;

const Wrapper = styled.div`
  &.add-new-list-flow {
    padding: 10px 15px;
    > label {
      margin-top: 10px;
    }
    .sub-text {
      display: inline-block;
      font-size: 9px;
      margin-top: 3px;
      margin-left: 3px;
    }
    .wrapper {
      display: flex;
      .add-word-head {
        font-family: 'Roboto Slab';
        font-style: normal;
        font-weight: 500;
        font-size: 14.2222px;
        line-height: 19px;
        letter-spacing: -0.395062px;
        color: #5E7079; 
      }
    }
    .margined-input {
     .round-field {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: -0.379239px;
      color: #7E7E7E;
      padding: 10px;
      scrollbar-width: thin;
      scrollbar-color: #001760 transparent;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 5px;
      }
      /* Track */
      &::-webkit-scrollbar-track {
        background: #fff;
        /* margin-top: 5px; */
        /* margin-bottom: 2px;  */
      }
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #001760;
      }
      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
      &::placeholder {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: -0.379239px;
      color: #7E7E7E;
      
      }
     }
    }
  }
  .error-message-styles{
    color: #db3725;
    font-style: italic;
    font-size: 14px;
    font-family: "robotomedium_italic";
    font-weight: normal;
  }
  input {
    margin-bottom: 20px;
  }
  transition: ease all 0.1s;
  box-sizing: border-box;
  background: #ecfaf1;
  padding: 1px 30px 30px 30px;
  border-radius: 15px 15px 5px 5px;
  margin: 25px 0;
  float: left;
  width: 100%;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 10px;
  }
  .intro-input {
    color: #5e7079;
    font-size: 14px;
    font-weight: 400;
    font-family: "Roboto", sans-serif;
    letter-spacing: -0.38px;
    margin-top: 8px;
  }
  .relative-input {
    position: relative;
    float: left;
    display: block;
    width: 100%;
    .browse {
      font-family: 'Roboto';
      font-weight: 700;
      font-size: 12px;
      color: #1EC252;
      border: 1px solid #1EC252;
      padding: 2px 8px;
      border-radius: 6px;
      cursor: pointer;
      letter-spacing: 1px;
      position: absolute;
      right: 0;
      top: 22px;
      width: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 9px;
        border-radius: 4px;
      }
    }
    input {
      margin-bottom: 0;
    }
  }
`;
